import { useEffect, useState } from 'react';
import axios from 'axios';
import { getApiBaseUrl } from '../apiBase';

/**
 * Есть ли на этом сервере APK для прямой загрузки (GET /api/download/apk-info, публичный).
 * Пока ответ не получен или файла нет, кнопку «Скачать APK» не показываем.
 */
export default function useApkInfo() {
    const [info, setInfo] = useState({ available: false, loaded: false });

    useEffect(() => {
        let cancelled = false;
        axios.get(`${getApiBaseUrl()}/download/apk-info`)
            .then((r) => {
                if (!cancelled) setInfo({ available: !!r.data?.androidAvailable, loaded: true, version: r.data?.version, sizeMb: r.data?.apkSizeMb });
            })
            .catch(() => { if (!cancelled) setInfo({ available: false, loaded: true }); });
        return () => { cancelled = true; };
    }, []);

    return info;
}
